export default __webpack_public_path__ + "static/image1-954d95ff5c2c593d75f11cb7af9ede21.jpg";